export class AppointmentsAssociatesAddressesQueryParameters {
  appointmentDateFrom?: string;
  appointmentDateTo?: string;
  id?: string;
  associateId?: string;
  department?: string;
  employeeId?: string;
  page?: number;
  pageSize?: number;
  rooftopId?: string;
  salespersonId?: number;
  search?: string;
  serviceAdvisorId?: string;
  serviceCode?: string;
  statusId?: string;
  tagNumber?: string;
  technicianGroupId?: string;
  technicianId?: string;
  transportOptionId?: string;
  vehicleId?: string;

  constructor(obj?: AppointmentsAssociatesAddressesQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
